import { render, staticRenderFns } from "./period-table.vue?vue&type=template&id=4fd23b87&scoped=true&"
import script from "./period-table.ts?vue&type=script&lang=ts&"
export * from "./period-table.ts?vue&type=script&lang=ts&"
import style0 from "./period-table.scss?vue&type=style&index=0&id=4fd23b87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd23b87",
  null
  
)

export default component.exports